//标题字符数小于等于18个时，字号为70 大于50
const fontSize = (str) => {
  if (!str) return;
  const size = str.length > 18 ? 0.5 : 0.7;
  return size + "rem";
};

//url转对象
const getURLParams = () => {
  const hash = window.location.hash || window.location.search;
  try {
    var params = hash;
    params = params
      .replace(/^[?#]*/g, "")
      .split("?")[1]
      .split("&");
    var obj = {};
    for (var i = 0, len = params.length; i < len; i++) {
      var e = params[i].split("=");
      obj[e[0]] = decodeURIComponent(e[1]);
    }
    return obj;
  } catch (err) {
    return {};
  }
};

//时间戳转日期
const formatDate = (str) => {
  let date = new Date(str);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  let day = date.getDate();
  day = day < 10 ? "0" + day : day;
  return year + "年" + month + "月" + day + "日";
};

export const isPermanentValid = (time) => {
  let now = new Date().getTime();
  let timeStamp = new Date(time).getTime();
  return timeStamp - now > 3650 * 24 * 60 * 60 * 1000 ? true : false;
}

//时间戳
const timestampFn = () => {
  return new Date().valueOf();
};

//是否在微信内
const isWx = () => {
  let wx = navigator.userAgent.toLowerCase();
  // eslint-disable-next-line eqeqeq
  if (wx.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  }
  return false;
};

//是否在微信内小程序 兼容iOS和安卓设备
export const isInWechatMP = () => {
  return (navigator.userAgent.match(/micromessenger/i) || navigator.userAgent.match(/miniprogram/i)) || window.__wxjs_environment === 'miniprogram';
};

export const isInMiniprogram = () => {
  return /miniprogram/i.test(navigator.userAgent);
}

// 手机号脱敏
const phoneDesensitization = (str = "") => {
  const pat = /(\d{3})\d*(\d{4})/;
  const _str = str.replace(pat, "$1****$2");
  return _str;
};

// 是否apple 设备
const apple = () => {
  return /macintosh|mac os x/i.test(navigator.userAgent);
};

//手机型号
const deviceType = (str) => {
  let equipment = "";
  let ua = navigator.userAgent.toLowerCase();
  if (/android|adr/gi.test(ua)) {
    // 安卓
    equipment = "android";
  } else if (/iPad/gi.test(ua)) {
    //ipad
    equipment = "ipad";
  } else if (/\(i[^;]+;( U;)? CPU.+Mac OS X/gi.test(ua)) {
    //苹果
    equipment = "iphone";
  }
  if (equipment.toUpperCase() === str.toUpperCase()) return true;
};
//是不是在webview中
const isWebview = () => {
  if (getURLParams()?.commonParas) {
    return true;
  } else {
    return false;
  }
};

//是不是在webview中的iphone
const iphoneAdaptation = () => {
  if (isWebview()) {
    return deviceType("iphone");
  } else {
    return false;
  }
};

const addPopstatePage = () => {
  if (isWebview()) {
    return true;
  } else {
    return false;
  }
};
//sdk返回的链接
const isSdkBack = () => {
  if (getURLParams()?.sdkBackUrl) {
    return true;
  } else {
    return false;
  }
};

//用户购买过但是现在过期了
const havePurchased = (serverTime, vipExpiration) => {
  return vipExpiration > serverTime ? true : false;
};

//字母转数字
function lettersToNumbers(inputString) {
  let result = "";
  for (let i = 0; i < inputString.length; i++) {
    let charCode = inputString.charCodeAt(i) - 97; // 获取字符的Unicode码，并减去'a'的Unicode码(97)
    result += charCode + "";
  }
  return Number(result.trim());
}

const iosUa = () => {
  let u = navigator.userAgent;
  if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    return true;
  } else {
    return false;
  }
};

const ROUTE_VALUE = (key) => {
  const URL = window.location.href;
  const VALUE =
    URL.match(/invitationCode=([^?&#]+)/) &&
    URL.match(/invitationCode=([^?&#]+)/)[1];

  return VALUE;
};

const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

export function isIOS() {
  return /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
}

/**
 * 复制文本到剪切板
 * @param {string} str 待复制的文本
 * @param {Function} successCb 复制成功cb
 * @param {Function} failCb 复制失败cb
 * @returns
 */

export function copy(str, successCb, failCb) {
  if (navigator.clipboard) { // 兼容性问题比较大
    // clipboard api 复制
    navigator.clipboard.writeText(str).then(() => {
      successCb && successCb();
    }).catch(() => {
      failCb && failCb();
    });
    return;
  }
  var res;
  var ta = document.createElement('textarea');
  ta.readOnly = true;
  ta.innerText = str;
  ta.style.opacity = '0';
  ta.style.position = 'fixed';
  ta.left = -1000;
  ta.bottom = -1000;
  document.body.appendChild(ta);
  if (isIOS()) {
      ta.setSelectionRange(0, ta.value.length);
  } else {
      ta.select();
  }
  this.timer = window.setTimeout(function () {
      try {
          res = document.execCommand("Copy");
          if (res) {
              successCb && successCb();
          } else {
              failCb && failCb();
          }
      } catch (e) {
          failCb && failCb(e);
      } finally {
          document.body.removeChild(ta);
      }
  }, 0);
  return res;
}

export function showToast(title, mask = true, duration = 1500) {
  if(!title)  return false

  let toastList = document.getElementsByClassName('liu-toast')
  for(let i = 0; i < toastList.length; i++) {
      toastList[i].remove()
  }
  let toastHtml = document.createElement('div')
  toastHtml.className = 'liu-toast'
  if(mask) {
      toastHtml.style = 'position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; opacity: 0; transition: opacity .2s;'
  }
  let toast = document.createElement('div')
  toast.style = 'position: absolute; left: 50%; bottom: 50%; transform: translateX(-50%); min-height: 32px; line-height: 18px; background-color: rgba(0, 0, 0, 0.6); padding: 7px 10px; color: #fff; font-size: 12px; text-align: center; border-radius: 6px; box-sizing: border-box;'
  let toastText = document.createElement('div')
  toastText.style = 'text-overflow: -o-ellipsis-lastline; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 4; line-clamp: 4; -webkit-box-orient: vertical;'
  let text = document.createTextNode(title);
  toastText.appendChild(text);
  toast.appendChild(toastText)
  toastHtml.appendChild(toast)
  document.body.appendChild(toastHtml)
  setTimeout(() => {
      toastHtml.style.opacity = 1
  });
  setTimeout(() => {
      toastHtml.style.opacity = 0
      setTimeout(() => {
          toastHtml.remove()
      }, 200);
  }, duration);
}

export function preloadImgs(imgs) {
  return Promise.all(imgs.map((img) => preloadImg(img)));
}


export function preloadImg(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve(img);
    };
    img.onerror = () => {
      reject(new Error('图片加载失败'));
    };
    img.src = src;
  })
}

export {
  fontSize,
  timestampFn,
  isWx,
  formatDate,
  phoneDesensitization,
  isWebview,
  iphoneAdaptation,
  addPopstatePage,
  isSdkBack,
  getURLParams,
  apple,
  havePurchased,
  lettersToNumbers,
  iosUa,
  ROUTE_VALUE,
  shuffleArray,
};
